<script setup lang="ts">
import { computed } from 'vue';
import { ItemName } from '../_shared';
import { getItemIcon } from '../file-item/get-file-icon';
import { ICON_PIXEL_SIZES } from '@/components/document/sub-components/file-manager/views/file-explorer-view/iconSize';
import type { FileExplorerIconSize } from '@/components/document/sub-components/file-manager/logic/core/useFileManagerSettings';
import type { FolderLikeItem } from '@/components/document/sub-components/file-manager/types';

const props = defineProps<{
  item: FolderLikeItem;
  iconSize: FileExplorerIconSize;
}>();

const folderIcon = computed(() => getItemIcon(props.item));
const pixelSize = computed(() => ICON_PIXEL_SIZES[props.iconSize]);
</script>

<template>
  <component :is="folderIcon.icon" :size="pixelSize" weight="fill" :color="folderIcon.color" />
  <ItemName :name="item.name" :icon-size="iconSize" />
</template>
